// // src/pages/BlogsPage.jsx

// import React, { useState } from 'react';
// import Header from '../components/Header';
// import Footer from '../components/Footer';
// import WhatsAppButton from '../components/WhatsAppButton';
// import ServiceRequestForm from '../components/ServiceRequestForm';
// import ScrollToTop from '../components/ScrollToTop';
// import { content } from '../data/content';
// import { globalStyles } from '../styles/globalStyles';
// import ArticlesSection from '../components/ArticlesSection';

// const BlogsPage = () => {
//   const [language, setLanguage] = useState('mr');

//   return (
//     <>
//       <style>{globalStyles}</style>
      
//       <div>
//         {/* Header with Navigation */}
//         <Header language={language} setLanguage={setLanguage} content={content} />
        
//         {/* Page Title Section */}
//         <section style={{
//           background: 'linear-gradient(-45deg, #c94b4b, #4b134f, #1e3a8a, #065f46)',
//           backgroundSize: '400% 400%',
//           animation: 'gradientShift 15s ease infinite',
//           padding: '80px 0 60px',
//           textAlign: 'center'
//         }}>
//           <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
//             <h1 style={{
//               fontSize: '48px',
//               color: 'white',
//               marginBottom: '16px',
//               fontWeight: '800',
//               textShadow: '2px 2px 4px rgba(0, 0, 0, 0.2)'
//             }}>
//               {language === 'mr' ? 'ब्लॉग आणि लेख' : 'Blogs & Articles'}
//             </h1>
//             <p style={{
//               fontSize: '20px',
//               color: 'rgba(255, 255, 255, 0.95)',
//               textShadow: '1px 1px 2px rgba(0, 0, 0, 0.1)'
//             }}>
//               {language === 'mr' 
//                 ? 'माहिती, मार्गदर्शक आणि अपडेट्स' 
//                 : 'Information, Guides and Updates'}
//             </p>
//           </div>
//         </section>
        
//         {/* Articles Section */}
//         <ArticlesSection language={language} />
        
//         {/* Footer */}
//         <Footer language={language} />
        
//         {/* Floating Components */}
//         <WhatsAppButton phoneNumber="918850415838" message="Hello, I need help with a service" />
//         <ServiceRequestForm language={language} content={content} />
//         <ScrollToTop />
//       </div>
//     </>
//   );
// };

// export default BlogsPage;



// src/Pages/BlogsPage.js

// import React from 'react';
// import { useLanguage } from '../context/LanguageContext';
// import ArticlesSection from '../components/ArticlesSection';
// import { globalStyles } from '../styles/globalStyles';
// import Header from '../components/Header';

// const BlogsPage = () => {
//   const { language } = useLanguage();

//   const content = {
//     en: {
//       title: "All Articles",
//       subtitle: "Browse our complete collection of guides, updates, and stories"
//     },
//     mr: {
//       title: "सर्व लेख",
//       subtitle: "मार्गदर्शक, अपडेट्स आणि कथांचा आमचा संपूर्ण संग्रह पहा"
//     }
//   };

//   const t = content[language];

//   return (
//     <div className="blogs-page">
     
//     <style>{globalStyles}</style>

//      <Header language={language} content={content} />
        
//         {/* Page Title Section */}
//         <section style={{
//           background: 'linear-gradient(-45deg, #c94b4b, #4b134f, #1e3a8a, #065f46)',
//           backgroundSize: '400% 400%',
//           animation: 'gradientShift 15s ease infinite',
//           padding: '80px 0 60px',
//           textAlign: 'center'
//         }}>
//           <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
//             <h1 style={{
//               fontSize: '48px',
//               color: 'white',
//               marginBottom: '16px',
//               fontWeight: '800',
//               textShadow: '2px 2px 4px rgba(0, 0, 0, 0.2)'
//             }}>
//               {language === 'mr' ? 'ब्लॉग आणि लेख' : 'Blogs & Articles'}
//             </h1>
//             <p style={{
//               fontSize: '20px',
//               color: 'rgba(255, 255, 255, 0.95)',
//               textShadow: '1px 1px 2px rgba(0, 0, 0, 0.1)'
//             }}>
//               {language === 'mr' 
//                 ? 'माहिती, मार्गदर्शक आणि अपडेट्स' 
//                 : 'Information, Guides and Updates'}
//             </p>
//           </div>
//         </section>

//       {/* ArticlesSection automatically uses language from context */}
//       <ArticlesSection />
//     </div>
//   );
// };

// export default BlogsPage;


// src/Pages/BlogsPage.js

import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import ArticlesSection from '../components/ArticlesSection';
import { globalStyles } from '../styles/globalStyles';
import Header from '../components/Header';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';
import ServiceRequestForm from '../components/ServiceRequestForm';
import ScrollToTop from '../components/ScrollToTop';
import { content } from '../data/content'; // Import the full content object

const BlogsPage = () => {
  const { language } = useLanguage();

  const pageContent = {
    en: {
      title: "Blogs & Articles",
      subtitle: "Information, Guides and Updates"
    },
    mr: {
      title: "ब्लॉग आणि लेख",
      subtitle: "माहिती, मार्गदर्शक आणि अपडेट्स"
    }
  };

  const t = pageContent[language];

  return (
    <>
      <style>{globalStyles}</style>
      <style>{`
       .blog-page-banner::before {
          content: '';
          position: absolute;
          top: -120%;
          right: -10%;
          width: 500px;
          height: 500px;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 50%;
        }

        .blog-page-banner::after {
          content: '';
          position: absolute;
          bottom: -85%;
          left: -5%;
          width: 400px;
          height: 400px;
          background: rgba(255, 255, 255, 0.08);
          border-radius: 50%;
        }
      `
        
        }</style>
      <div className="blogs-page">
        {/* Header with Navigation - uses full content object */}
        <Header language={language} content={content} />
        
        {/* Page Title Section */}
        <section className='blog-page-banner' style={{
          position:"relative",
          overflow:"hidden",
          background: 'linear-gradient(-45deg, #c94b4b, #4b134f, #1e3a8a, #065f46)',
          backgroundSize: '400% 400%',
          animation: 'gradientShift 15s ease infinite',
          padding: '80px 0 60px',
          textAlign: 'center'
        }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
            <h1 style={{
              fontSize: '48px',
              color: 'white',
              marginBottom: '16px',
              fontWeight: '800',
              textShadow: '2px 2px 4px rgba(0, 0, 0, 0.2)'
            }}>
              {t.title}
            </h1>
            <p style={{
              fontSize: '20px',
              color: 'rgba(255, 255, 255, 0.95)',
              textShadow: '1px 1px 2px rgba(0, 0, 0, 0.1)'
            }}>
              {t.subtitle}
            </p>
          </div>
        </section>

        {/* ArticlesSection automatically uses language from context */}
        <ArticlesSection />
        
        {/* Footer */}
        <Footer language={language} />
        
        {/* Floating Components */}
        <WhatsAppButton phoneNumber="918850415838" message="Hello, I need help with a service" />
        <ServiceRequestForm language={language} content={content} />
        <ScrollToTop />
      </div>
    </>
  );
};

export default BlogsPage;